// extracted by mini-css-extract-plugin
module.exports = {"partnersListTitle":"ih2ME","partnersList":"_1vEBl","partnersCustomScrollbar":"_1Od9e"};